import React from 'react';
import PropTypes from 'prop-types';

// material-ui
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

// assets
import MoreIcon from '@mui/icons-material/MoreVert';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';

const ProfileSection = ({ onContactOpen }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleItemClick = (target) => () => {
        switch (target) {
            case 'login':
                window.open('https://los-main.com/login', '_blank');
                break;
            case 'investoren':
                window.open('https://heureka-relations.com/', '_blank');
                break;
            case 'contact':
                onContactOpen();
                break;
            default:
                break;
        }

        handleClose();
    };

    return (
        <React.Fragment>
            <Tooltip title="Account settings">
                <IconButton
                    onClick={handleClick}
                    aria-haspopup="true"
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    sx={{ p: 0 }}
                >
                    <MoreIcon />
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleItemClick('investoren')}>
                    <Avatar sx={{ bgcolor: 'primary.main' }} /> Investoren
                </MenuItem>
                <MenuItem onClick={handleItemClick('login')}>
                    <Avatar sx={{ bgcolor: 'primary.main' }} /> Login
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleItemClick('contact')}>
                    <ListItemIcon>
                        <ContactsOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Contact
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

ProfileSection.propTypes = {
    onContactOpen: PropTypes.func.isRequired,
};

export default ProfileSection;
